import { Skeleton, Box } from "@mui/material";

const ProductTypesSkeleton = () => {
  return (
    <section className="flat-spacing-20">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="tf-categories-wrap">
              <div className="tf-categories-container">
                {Array.from({ length: 7 }).map((_, index) => (
                  <Box
                    key={index}
                    className="collection-item-circle hover-img"
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    {/* Circle Skeleton for Image */}
                    <Skeleton
                      variant="circular"
                      width={60}
                      height={60}
                      className="collection-image"
                    />
                    {/* Text Skeleton */}
                    <Skeleton
                      variant="text"
                      width={60}
                      height={15}
                      className="collection-content"
                      sx={{ mt: 1 }}
                    />
                  </Box>
                ))}
              </div>
              <div className="tf-shopall-wrap">
                <Box
                  className="collection-item-circle tf-shopall"
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  {/* Circle Skeleton for 'Shop All' Icon */}
                  <Skeleton
                    variant="circular"
                    width={75}
                    height={75}
                    className="collection-image tf-shopall-icon"
                  />
                  {/* Text Skeleton */}
                  <Skeleton
                    variant="text"
                    width={60}
                    height={20}
                    className="collection-content"
                    sx={{ mt: 1 }}
                  />
                </Box>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductTypesSkeleton;
